var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0013 2.33223L9.66797 4.9989M10.6686 11.9989C10.315 11.9989 9.97587 11.8584 9.72583 11.6084C9.47578 11.3583 9.3353 11.0192 9.3353 10.6656C9.3353 10.3119 9.47578 9.97281 9.72583 9.72276C9.97587 9.47271 10.315 9.33223 10.6686 9.33223M10.6686 11.9989C11.0223 11.9989 11.3614 11.8584 11.6114 11.6084C11.8615 11.3583 12.002 11.0192 12.002 10.6656C12.002 10.3119 11.8615 9.97281 11.6114 9.72276C11.3614 9.47271 11.0223 9.33223 10.6686 9.33223M10.6686 11.9989V12.9989M10.6686 9.33223V8.33223M12.6893 9.4989L11.8233 9.9989M9.51464 11.3322L8.64797 11.8322M8.64797 9.4989L9.51464 9.9989M11.8233 11.3322L12.69 11.8322M0.667969 11.3322H3.33464L10.3346 4.33223C10.5097 4.15714 10.6486 3.94927 10.7434 3.72049C10.8381 3.49172 10.8869 3.24652 10.8869 2.9989C10.8869 2.75128 10.8381 2.50608 10.7434 2.2773C10.6486 2.04853 10.5097 1.84066 10.3346 1.66557C10.1595 1.49047 9.95167 1.35158 9.7229 1.25682C9.49412 1.16205 9.24892 1.11328 9.0013 1.11328C8.75368 1.11328 8.50848 1.16205 8.27971 1.25682C8.05093 1.35158 7.84306 1.49047 7.66797 1.66557L0.667969 8.66557V11.3322Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.fd4bb8feb07ae0d670b024bdd484bb8d.svg";
export { ForwardRef as ReactComponent };